import { Component, Input } from '@angular/core';

export type SeccionDiseno = 'asociaciones' | 'asociados' | 'ejercicios' | 'cargos' | 'historico' | 'admin';

/** Cabecera de página del sistema de diseño (Wave 7): icono de sección, título (h1), descripción opcional y acciones proyectadas. */
@Component({
  selector: 'app-page-header',
  standalone: true,
  template: `
    <header class="page-header" [attr.data-seccion]="seccion">
      <span class="page-header__icon" aria-hidden="true"><i class="bi" [class]="icono"></i></span>
      <div class="page-header__text">
        <h1>{{ titulo }}</h1>
        @if (descripcion) { <p>{{ descripcion }}</p> }
      </div>
      <div class="page-header__actions"><ng-content></ng-content></div>
    </header>
  `
})
export class PageHeaderComponent {
  @Input({ required: true }) titulo = '';
  @Input() descripcion = '';
  @Input() icono = 'bi-grid-fill';
  @Input() seccion: SeccionDiseno | '' = '';
}
